import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import {
  Card,
  Col,
  Form,
  List,
  Modal,
  notification,
  Popconfirm,
  Row,
  Typography,
} from 'antd';
import { FormInstance } from 'antd/lib/form';
import { indexBy, setValueByNamePath, shouldUpdateCompare } from 'utils/utils2';
import { PlusOutlined } from '@ant-design/icons';
import _, { debounce, isNil } from 'lodash';
import SliderWithInput from 'components/SliderWithInput';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalControllerNV from 'components/ModalControllerNV';
import TabAssetUseHistoryModal from './AssetUseHistoryModal';
import moment from 'moment';
import ButtonOperation from 'components/ButtonOperation';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataTable/DataTable';
import IrvScheduleButton from 'components/IrvScheduleButton';
import AssetDVuseScheduleModal from './AssetFVUseContextSchModal';
import AssetfvscheduleModal from './AssetFVScheduleModal';
import AddAssetFVModal from './AddAssetFVModal';
import DeleteButton from 'components/DeleteButton';
import Button from 'components/Button';
import {
  AssetFutureValueResponse,
  deleteAssetfutureValueByContextId,
} from 'services/assets';
import AssetFVMergedScheduleModal from './AssetFVMergedScheduleModal';
import AddAssetUseValueModal from './AddAssetUseValueModal';
import { EntityAdditionalAttributeRequest } from 'services/assetconfig';
import { getParAssetUseConditionDetailByUsedid } from 'services/pricing';
import { AuthContext } from 'components/Auth/Auth';

type TabAssetUseProps = {
  form: FormInstance;
  isproposalcreate?: boolean;
  fromproposal?: boolean;
  isAssetCreate?: boolean;
  assetPhase: any;
  assetDetail: any;
  proposalData?: any;
  assetFV?: Array<AssetFutureValueResponse>;
  irvSchedule: any;
  refetchassetFV?: () => void;
  refetchassetUse?: () => void;
};
const { confirm } = Modal;

const TabAssetUse = (props: TabAssetUseProps) => {
  const {
    form,
    fromproposal,
    isproposalcreate,
    isAssetCreate,
    assetDetail,
    assetFV,
    irvSchedule,
    assetPhase,
    refetchassetFV,
    refetchassetUse,
    proposalData,
  } = props;

  const fieldName = 'listItemData';
  const { isInspect } = useContext(AuthContext);
  useEffect(() => {
    if (!isNil(form.getFieldValue('listAssetUse'))) {
      form.setFieldsValue({
        [fieldName]: _.uniqBy(form.getFieldValue('listAssetUse'), 'attcode'),
      });
    }
  }, [form, form.getFieldValue('listAssetUse')]);

  if (form.getFieldValue(fieldName) === undefined) {
    form.setFieldsValue({
      [fieldName]: [],
    });
  }
  const getName = useCallback(
    (name: string) => (id: number) => {
      const listuse = form.getFieldValue('listAssetUse');
      const index = indexBy(listuse, 'useid')[id];

      return ['listAssetUse', index, name];
    },
    [form]
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'contextoriginlabel',
        width: 150,
        fixed: 'left',
      },
      {
        dataIndex: 'contextcodelabel',
        width: 180,
      },
      {
        dataIndex: 'fvtypelabel',
        width: 140,
      },
      {
        dataIndex: 'contextidoriginlabel',
        width: 130,
      },

      {
        dataIndex: 'prcodelabel',
        width: 140,
      },
      {
        dataIndex: 'ofrtypelabel',
        width: 140,
      },
      {
        dataIndex: 'ofrlabel',
        width: 140,
      },
      {
        dataIndex: 'duration',
        width: 140,
      },
      {
        dataIndex: 'creationdate',
        width: 140,
        render: (value, record, index) =>
          !isNil(value) ? moment(value).format('YYYY-MM-DD') : '',
      },
      {
        dataIndex: 'contextstatuslabel',
        width: 140,
      },
      {
        dataIndex: 'fvContextUse',
        width: 170,
        fixed: 'right',
        render: (val, record) => (
          <AssetDVuseScheduleModal
            AssetfvcontextuseResponse={val}
            controller={<Button comcode="ListFVContextUse" />}
          />
        ),
      },
      {
        dataIndex: 'fvSchedule',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: (val, record) => (
          <AssetfvscheduleModal
            assetfvschedule={val}
            controller={
              <IrvScheduleButton
                onlyicon
                comcode="FVScheduleButton"
                twoToneColor="red"
                style={{
                  height: 33,
                }}
              />
            }
          />
        ),
      },

      {
        dataIndex: 'actions',
        width: 150,
        fixed: 'right',
        align: 'center',
        render: (val, record) => (
          <Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => {
              handleDeleteContext(record.contextid);
            }}
            okText="Yes"
            cancelText="No"
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
      },
    ],
    []
  );
  const HandleAddLine = (values: any) => {
    //todo
  };

  const handleDeleteContext = async (id: any) => {
    await deleteAssetfutureValueByContextId({ contextid: id })
      .then((res) => {
        notification.success({ message: res.message });
        refetchassetFV && refetchassetFV();
      })
      .catch((res) => {
        notification.error({ message: res.message });
      });
  };

  const setDisabled = () => {
    if (fromproposal) {
      return false;
    } else {
      if (assetDetail?.assetstatus === 'INIT') {
        return false;
      } else {
        return true;
      }
    }
  };

  const getAssetUseConditionDetailByUsedid = debounce(
    async (useid: number, usevalue: number, item: any) => {
      getParAssetUseConditionDetailByUsedid({ useid, usevalue }).then((res) => {
        if (res.data.priidexceed !== item.priidexceed) {
          confirm({
            style: { width: 500, top: 200 },
            icon: undefined,
            content: (
              <Card title="Usage Limit change ">
                <span>
                  This usage change will apply a new Exceed fees. Do you confirm
                  ?
                </span>
              </Card>
            ),
            onOk() {
              setValueByNamePath(
                form,
                getName('priidexceedlabel')(useid),
                res.data.priidexceedlabel
              );
              setValueByNamePath(
                form,
                getName('priidexceed')(useid),
                res.data.priidexceed
              );
            },
            okText: 'Yes',
            cancelText: 'No',
            onCancel() {
              return false;
            },
          });
        }
      });
    },
    1000
  );

  return (
    <>
      <Card type="inner" title={<GetLabel label="Assetuse" style={{fontWeight:'bold',paddingLeft:15}}/>}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            return (
              <List
                itemLayout="horizontal"
                header={
                  <Row>
                    <Col span={15}>
                      <Typography.Title level={5}>
                        <GetLabel label="Attribute" />
                      </Typography.Title>
                    </Col>

                    <Col span={9}>
                      <Row justify="start">
                        <Col span={10}>
                          <Typography.Title level={5}>
                            <GetLabel label="ExceedFormula" />
                          </Typography.Title>
                        </Col>
                        <Col>
                          <Typography.Title level={5}>
                            <GetLabel label="LastRegistredUse" />
                          </Typography.Title>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                }
                dataSource={getFieldValue('listAssetUse') ?? []}
                rowKey="useid"
                renderItem={(item: any) => {
                  return (
                    <List.Item
                      actions={[
                        <div key="k1">
                          {!isNil(item?.lastregistredusevalue) ? (
                            <ModalControllerNV
                              modal={({ setVisible, visible }) => (
                                <TabAssetUseHistoryModal
                                  onClose={() => setVisible(false)}
                                  visible={visible}
                                  data={item.useValues.map((use: any) => ({
                                    ...use,
                                    uselabel: item.uselabel,
                                  }))}
                                />
                              )}
                              content={({ setVisible, visible }) => (
                                <a onClick={() => setVisible(true)}>
                                  <strong>
                                    {item?.lastregistredusevalue +
                                      ' ' +
                                      item?.useunittype}
                                  </strong>
                                </a>
                              )}
                            />
                          ) : (
                            <GetLabel label="Novalueentered" />
                          )}
                        </div>,
                        <div key="k2">
                          {!isNil(item?.lastregistredusedate) ? (
                            <strong>
                              {moment(item?.lastregistredusedate).format(
                                'YYYY-MM-DD'
                              )}
                            </strong>
                          ) : (
                            <GetLabel label="Novalueentered" />
                          )}
                        </div>,
                      ]}
                      extra={
                        <ModalControllerNV
                          modal={({ setVisible, visible }) => (
                            <AddAssetUseValueModal
                              phase={assetPhase}
                              onClose={() => setVisible(false)}
                              visible={visible}
                              refetchassetUse={refetchassetUse}
                              use={item}
                              assetdetail={assetDetail}
                            />
                          )}
                          content={({ setVisible, visible }) => (
                            <ButtonOperation
                              type="primary"
                              icon={<PlusOutlined onClick={() =>isInspect&& setVisible(true)}/>}
                              onClick={() =>!isInspect&& setVisible(true)}
                              comcode="new"
                            />
                          )}
                        />
                      }
                    >
                      <List.Item.Meta
                        title={
                          <span>
                            <strong>{item.uselabel}</strong>
                            &nbsp; {item.useunitperiodlabel }
                          </span>
                        }
                        description={
                          <FormInput
                            name={getName('usevalue')(
                              item.useid
                            )}
                            noStyle
                          >
                            <SliderWithInput
                              max={item.maxvalue}
                              min={item.minvalue}
                              precision={0}
                              gutter={64}
                              widthInput={8}
                              key={item.useid}
                              disabled={setDisabled()}
                              widthSlider="80%"
                              minmarks={
                                !isNil(item?.useunitperiod)
                                  ? !isNil(item?.useunittype)
                                    ? item.minvalue +
                                      ' ' +
                                      item?.useunittype +
                                      ' / ' +
                                      item?.useunitperiodlabel
                                    : item.minvalue +
                                      ' / ' +
                                      item?.useunitperiodlabel
                                  : !isNil(item?.useunittype)
                                  ? item.minvalue + ' ' + item?.useunittype
                                  : item.minvalue
                              }
                              maxmarks={{
                                style: {
                                  color: '#f50',
                                  width: '100%',
                                },
                                label: !isNil(item?.useunitperiod) ? (
                                  !isNil(item?.useunittype) ? (
                                    <strong>
                                      {item.maxvalue +
                                        ' ' +
                                        item?.useunittype +
                                        ' / ' +
                                        item?.useunitperiodlabel}
                                    </strong>
                                  ) : (
                                    <strong>
                                      {item.maxvalue +
                                        ' / ' +
                                        item?.useunitperiodlabel}
                                    </strong>
                                  )
                                ) : !isNil(item?.useunittype) ? (
                                  <strong>
                                    {item.maxvalue + ' ' + item?.useunittype}
                                  </strong>
                                ) : (
                                  <strong>{item.maxvalue}</strong>
                                ),
                              }}
                              onChange={(val: any) => {
                                getAssetUseConditionDetailByUsedid(
                                  item.useid,
                                  val,
                                  item
                                );
                              }}
                            />
                          </FormInput>
                        }
                      />

                      <Typography.Text>
                        {!isNil(item.priidexceedlabel) ? (
                          item.priidexceedlabel
                        ) : !isNil(item.priidexceedLabel) ? (
                          item.priidexceedLabel
                        ) : (
                          <GetLabel label="Novalueentered" />
                        )}
                      </Typography.Text>
                    </List.Item>
                  );
                }}
              />
            );
          }}
        </Form.Item>
      </Card>
      <Form.Item noStyle shouldUpdate={shouldUpdateCompare(fieldName)}>
        {({ getFieldValue }) => {
          const listOfInit = getFieldValue(fieldName).map((line: any) =>
            _.pick(
              {
                attcode: line?.attcode,
                usevalue: line?.usevalue,
                usevaluedate: line?.usevaluedate,
              },
              ['attcode', 'usevalue', 'usevaluedate']
            )
          );
          const attributeList = assetDetail?.entityAddAttributList?.map(
            (att: EntityAdditionalAttributeRequest) => {
              return {
                critcode: att.attcode,
                critvalue: att.attstringvalue ?? att.attnumericvalue,
              };
            }
          );

          return (
            <Card
              type="inner"
              title={<GetLabel label="AssetFutureValue" />}
              extra={
                <>
                  {assetFV !== undefined && assetFV?.length > 0 ? (
                    <AssetFVMergedScheduleModal
                      fvContext={assetFV ?? []}
                      controller={
                        <IrvScheduleButton
                          comcode="showAllFvContext"
                          twoToneColor="red"
                          style={{
                            height: 33,
                          }}
                        />
                      }
                    />
                  ) : null}
                  &nbsp;&nbsp;
                  <ModalControllerNV
                    modal={({ setVisible, visible }) => (
                      <AddAssetFVModal
                        irvSchedule={irvSchedule}
                        proposalData={proposalData}
                        onClose={() => setVisible(false)}
                        visible={visible}
                        fromproposal={fromproposal}
                        onAdd={HandleAddLine}
                        refetchassetFV={refetchassetFV}
                        assetDetail={assetDetail}
                        usecondition={listOfInit}
                        attributeList={attributeList}
                      />
                    )}
                    content={({ setVisible, visible }) => (
                      <ButtonOperation
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setVisible(true)}
                        comcode="addFvContext"
                      />
                    )}
                  />
                </>
              }
            >
              <DataGrid
                columns={columns}
                dataSource={_.values(assetFV)}
                pagination={false}
                rowKey="contextid"
                size="small"
                hideFilters
                bordered
              />
            </Card>
          );
        }}
      </Form.Item> 
    </>
  );
};

export default TabAssetUse;
